
import { useState } from 'react';
import { useToast } from '@/hooks/use-toast';
import { useStripeConnect } from '@/hooks/stripe/useStripeConnect';

/**
 * Hook for handling connection and disconnection of Stripe accounts
 */
export function useConnectionManagement(
  checkConnection: (force?: boolean) => Promise<void>,
  clearCache: () => void
) {
  const { toast } = useToast();
  const { 
    isConnecting, 
    handleConnect, 
    handleDisconnect: _handleDisconnect 
  } = useStripeConnect();
  
  const handleDisconnect = async () => {
    try {
      console.log('[Stripe Debug] Disconnect initiated');
      await _handleDisconnect();
      
      // Clear cache and force refresh connection status
      clearCache();
      await checkConnection(true);
      
      console.log('[Stripe Debug] Disconnect complete, connection status refreshed');
    } catch (error: any) {
      console.error('[Stripe Debug] Error during Stripe disconnect:', error);
      toast({
        title: "Disconnect Error",
        description: error.message || "An error occurred while disconnecting",
        variant: "destructive"
      });
    }
  };

  return {
    isConnecting,
    handleConnect,
    handleDisconnect
  };
}
